<script lang="ts">
	import Header from '$lib/components/sections/Header.svelte';
	import Footer from '$lib/components/sections/Footer.svelte';
	import DocsLayout from '$lib/components/docs/DocsLayout.svelte';

	let { children } = $props();
</script>

<svelte:head>
	<!-- Fallback title only; leaf doc pages own their <title>, description,
	     canonical and OG tags. No <meta name="description"> here — it would
	     duplicate (and, being first, override) the per-page description. -->
	<title>Documentation - Heyweek</title>
</svelte:head>

<!-- Header spans full width -->
<Header />

<!-- Use shared DocsLayout component -->
<DocsLayout mode="docs">
	{@render children?.()}
</DocsLayout>

<!-- Footer spans full width -->
<Footer />